/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
};

export type BasicSymbol = {
  opacity?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  rotation?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  symbol: Scalars['String']['output'];
};

export type BasicSymbolInput = {
  opacity?: InputMaybe<Scalars['Float']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  rotation?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  symbol: Scalars['String']['input'];
};

export type BubbleConfigs = {
  classNumber?: Maybe<Scalars['Float']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<PointBubbleRadius>;
  symbolStyle?: Maybe<SymbolStyle>;
  symbolValues?: Maybe<Array<SymbolValue>>;
  valueField?: Maybe<Scalars['String']['output']>;
};

export type BubbleConfigsInput = {
  classNumber?: InputMaybe<Scalars['Float']['input']>;
  classification?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<PointBubbleRadiusInput>;
  symbolStyle?: InputMaybe<SymbolStyleInput>;
  symbolValues?: InputMaybe<Array<SymbolValueInput>>;
  valueField?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDatasetInput = {
  datasourceType: DATASOURCE_TYPE;
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isPrivate: Scalars['Boolean']['input'];
  mapsCount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  type: GEOMETRY_TYPE;
  userId: Scalars['ID']['input'];
};

export type CreateLayerInput = {
  bubbleStyle?: InputMaybe<BubbleConfigsInput>;
  datasetId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  heatMapStyle?: InputMaybe<HeatMapConfigsInput>;
  labelsProps?: InputMaybe<LabelsInput>;
  layerGroupId: Scalars['ID']['input'];
  lineCategoryStyle?: InputMaybe<LineCategoryConfigsInput>;
  lineQuantityStyle?: InputMaybe<LineQuantityConfigsInput>;
  lineSimpleStyle?: InputMaybe<LineSimpleConfigsInput>;
  maxZoom?: InputMaybe<Scalars['Float']['input']>;
  minZoom?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pointCategoryStyle?: InputMaybe<PointCategoryConfigsInput>;
  pointQuantityStyle?: InputMaybe<PointQuantityConfigsInput>;
  pointSimpleStyle?: InputMaybe<PointSimpleConfigsInput>;
  polygonCategoryStyle?: InputMaybe<PolygonCategoryConfigsInput>;
  polygonQuantityStyle?: InputMaybe<PolygonQuantityConfigsInput>;
  polygonSimpleStyle?: InputMaybe<PolygonSimpleConfigsInput>;
  type: LAYER_STYLE_TYPE;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateMapInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export enum DATASOURCE_TYPE {
  CSV = 'CSV',
  GEOJSON = 'GEOJSON',
  GEO_DATABASE = 'GEO_DATABASE',
  KML = 'KML',
  RASTER = 'RASTER',
  SHAPEFILE = 'SHAPEFILE',
  TAB = 'TAB',
  WMS = 'WMS'
}

export type Dataset = {
  createdAt: Scalars['AWSDateTime']['output'];
  datasourceType?: Maybe<DATASOURCE_TYPE>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  mapsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  type: GEOMETRY_TYPE;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['String']['output'];
};

export type DatasetCollection = {
  items: Array<Dataset>;
  total: Scalars['Int']['output'];
};

export type FileUploadUrlResult = {
  formFieldsJson: Scalars['AWSJSON']['output'];
  uploadUrl: Scalars['AWSURL']['output'];
};

export type FillStyle = {
  color?: Maybe<Scalars['String']['output']>;
  fillType?: Maybe<Scalars['String']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type FillStyleInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  fillType?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  opacity?: InputMaybe<Scalars['Float']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export enum GEOMETRY_TYPE {
  LINE = 'LINE',
  POINT = 'POINT',
  POLYGON = 'POLYGON'
}

export type HeatMapBasicConfigs = {
  opacity?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
};

export type HeatMapBasicConfigsInput = {
  opacity?: InputMaybe<Scalars['Float']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};

export type HeatMapConfigs = {
  basic?: Maybe<HeatMapBasicConfigs>;
};

export type HeatMapConfigsInput = {
  basic?: InputMaybe<HeatMapBasicConfigsInput>;
};

export enum LAYER_STYLE_TYPE {
  BUBBLE = 'BUBBLE',
  HEATMAP = 'HEATMAP',
  LINE_CATEGORY = 'LINE_CATEGORY',
  LINE_QUANTITY = 'LINE_QUANTITY',
  LINE_SIMPLE = 'LINE_SIMPLE',
  POINT_CATEGORY = 'POINT_CATEGORY',
  POINT_QUANTITY = 'POINT_QUANTITY',
  POINT_SIMPLE = 'POINT_SIMPLE',
  POLYGON_CATEGORY = 'POLYGON_CATEGORY',
  POLYGON_QUANTITY = 'POLYGON_QUANTITY',
  POLYGON_SIMPLE = 'POLYGON_SIMPLE'
}

export type Label = {
  attribute?: Maybe<Scalars['String']['output']>;
  font?: Maybe<Scalars['String']['output']>;
  fontColour?: Maybe<Scalars['String']['output']>;
  fontOpacity?: Maybe<Scalars['Float']['output']>;
  fontSize?: Maybe<Scalars['Float']['output']>;
  fontStyle?: Maybe<Scalars['String']['output']>;
  haloColour?: Maybe<Scalars['String']['output']>;
  haloOpacity?: Maybe<Scalars['Float']['output']>;
  haloSize?: Maybe<Scalars['Float']['output']>;
};

export type LabelsInput = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  font?: InputMaybe<Scalars['String']['input']>;
  fontColour?: InputMaybe<Scalars['String']['input']>;
  fontOpacity?: InputMaybe<Scalars['Float']['input']>;
  fontSize?: InputMaybe<Scalars['Float']['input']>;
  fontStyle?: InputMaybe<Scalars['String']['input']>;
  haloColour?: InputMaybe<Scalars['String']['input']>;
  haloOpacity?: InputMaybe<Scalars['Float']['input']>;
  haloSize?: InputMaybe<Scalars['Float']['input']>;
};

export type Layer = {
  bubbleStyle?: Maybe<BubbleConfigs>;
  createdAt: Scalars['AWSDateTime']['output'];
  datasetId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  heatMapStyle?: Maybe<HeatMapConfigs>;
  id: Scalars['ID']['output'];
  labelsProps?: Maybe<Label>;
  layerGroupId: Scalars['ID']['output'];
  lineCategoryStyle?: Maybe<LineCategoryConfigs>;
  lineQuantityStyle?: Maybe<LineQuantityConfigs>;
  lineSimpleStyle?: Maybe<LineSimpleConfigs>;
  maxZoom?: Maybe<Scalars['Float']['output']>;
  minZoom?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pointCategoryStyle?: Maybe<PointCategoryConfigs>;
  pointQuantityStyle?: Maybe<PointQuantityConfigs>;
  pointSimpleStyle?: Maybe<PointSimpleConfigs>;
  polygonCategoryStyle?: Maybe<PolygonCategoryConfigs>;
  polygonQuantityStyle?: Maybe<PolygonQuantityConfigs>;
  polygonSimpleStyle?: Maybe<PolygonSimpleConfigs>;
  type: LAYER_STYLE_TYPE;
  updatedAt: Scalars['AWSDateTime']['output'];
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type LayerCollection = {
  items: Array<Layer>;
  total: Scalars['Int']['output'];
};

export type LayerGroup = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  layerCollection: LayerCollection;
  layersOrder: Array<Scalars['ID']['output']>;
  mapId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  visible: Scalars['Boolean']['output'];
};

export type LayerGroupCollection = {
  items: Array<LayerGroup>;
  total: Scalars['Int']['output'];
};

export type LineCategoryConfigs = {
  colorRamp?: Maybe<Scalars['String']['output']>;
  symbolStyle?: Maybe<SymbolStyle>;
  symbolValues?: Maybe<Array<SymbolValue>>;
  valueField?: Maybe<Scalars['String']['output']>;
};

export type LineCategoryConfigsInput = {
  colorRamp?: InputMaybe<Scalars['String']['input']>;
  symbolStyle?: InputMaybe<SymbolStyleInput>;
  symbolValues?: InputMaybe<Array<SymbolValueInput>>;
  valueField?: InputMaybe<Scalars['String']['input']>;
};

export type LineQuantityConfigs = {
  classNumber: Scalars['Float']['output'];
  classbreaks: Array<Scalars['Float']['output']>;
  classification: Scalars['String']['output'];
  colorRamp: Scalars['String']['output'];
  legendType: Scalars['String']['output'];
  symbolStyle: SymbolStyle;
  symbolValues: Array<SymbolValue>;
  valueField: Scalars['String']['output'];
};

export type LineQuantityConfigsInput = {
  classNumber: Scalars['Float']['input'];
  classbreaks: Array<Scalars['Float']['input']>;
  classification: Scalars['String']['input'];
  colorRamp: Scalars['String']['input'];
  legendType: Scalars['String']['input'];
  symbolStyle: SymbolStyleInput;
  symbolValues: Array<SymbolValueInput>;
  valueField: Scalars['String']['input'];
};

export type LineSimpleConfigs = {
  symbolStyle?: Maybe<SymbolStyle>;
};

export type LineSimpleConfigsInput = {
  symbolStyle?: InputMaybe<SymbolStyleInput>;
};

export type Map = {
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layerGroupCollection: LayerGroupCollection;
  layerGroupsOrder?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  name: Scalars['String']['output'];
  tools?: Maybe<Array<Maybe<Tool>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type MapCollection = {
  items: Array<Map>;
  total: Scalars['Int']['output'];
};

export type Mutation = {
  createDataset: Dataset;
  createLayer: Layer;
  createMap: Map;
  createPortalSettings: PortalSettings;
  deleteDataset: Scalars['Boolean']['output'];
  deleteLayer: Layer;
  deleteMap: Map;
  updatePortalSettings: PortalSettings;
  updateUser: User;
};


export type MutationcreateDatasetArgs = {
  input: CreateDatasetInput;
};


export type MutationcreateLayerArgs = {
  input: CreateLayerInput;
};


export type MutationcreateMapArgs = {
  input: CreateMapInput;
};


export type MutationcreatePortalSettingsArgs = {
  input: PortalSettingsInput;
};


export type MutationdeleteDatasetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteLayerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteMapArgs = {
  id: Scalars['ID']['input'];
};


export type MutationupdatePortalSettingsArgs = {
  id: Scalars['ID']['input'];
  input: PortalSettingsInput;
};


export type MutationupdateUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateUserInput;
};

export type Navigator = {
  active: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type NavigatorInput = {
  active: Scalars['Boolean']['input'];
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  index: Scalars['Int']['input'];
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type PointBubbleRadius = {
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type PointBubbleRadiusInput = {
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
};

export type PointCategoryConfigs = {
  colorRamp?: Maybe<Scalars['String']['output']>;
  symbolStyle?: Maybe<SymbolStyle>;
  symbolValues?: Maybe<Array<SymbolValue>>;
  valueField?: Maybe<Scalars['String']['output']>;
};

export type PointCategoryConfigsInput = {
  colorRamp?: InputMaybe<Scalars['String']['input']>;
  symbolStyle?: InputMaybe<SymbolStyleInput>;
  symbolValues?: InputMaybe<Array<SymbolValueInput>>;
  valueField?: InputMaybe<Scalars['String']['input']>;
};

export type PointQuantityConfigs = {
  classNumber: Scalars['Float']['output'];
  classbreaks: Array<Scalars['Float']['output']>;
  classification: Scalars['String']['output'];
  colorRamp: Scalars['String']['output'];
  legendType: Scalars['String']['output'];
  symbolStyle: SymbolStyle;
  symbolValues: Array<SymbolValue>;
  valueField: Scalars['String']['output'];
};

export type PointQuantityConfigsInput = {
  classNumber: Scalars['Float']['input'];
  classbreaks: Array<Scalars['Float']['input']>;
  classification: Scalars['String']['input'];
  colorRamp: Scalars['String']['input'];
  legendType: Scalars['String']['input'];
  symbolStyle: SymbolStyleInput;
  symbolValues: Array<SymbolValueInput>;
  valueField: Scalars['String']['input'];
};

export type PointSimpleConfigs = {
  symbolStyle?: Maybe<SymbolStyle>;
};

export type PointSimpleConfigsInput = {
  symbolStyle?: InputMaybe<SymbolStyleInput>;
};

export type PolygonCategoryConfigs = {
  colorRamp?: Maybe<Scalars['String']['output']>;
  symbolStyle?: Maybe<SymbolStyle>;
  symbolValues?: Maybe<Array<SymbolValue>>;
  valueField?: Maybe<Scalars['String']['output']>;
};

export type PolygonCategoryConfigsInput = {
  colorRamp?: InputMaybe<Scalars['String']['input']>;
  symbolStyle?: InputMaybe<SymbolStyleInput>;
  symbolValues?: InputMaybe<Array<SymbolValueInput>>;
  valueField?: InputMaybe<Scalars['String']['input']>;
};

export type PolygonQuantityConfigs = {
  classNumber: Scalars['Float']['output'];
  classbreaks: Array<Scalars['Float']['output']>;
  classification: Scalars['String']['output'];
  colorRamp: Scalars['String']['output'];
  legendType: Scalars['String']['output'];
  symbolStyle: SymbolStyle;
  symbolValues: Array<SymbolValue>;
  valueField: Scalars['String']['output'];
};

export type PolygonQuantityConfigsInput = {
  classNumber: Scalars['Float']['input'];
  classbreaks: Array<Scalars['Float']['input']>;
  classification: Scalars['String']['input'];
  colorRamp: Scalars['String']['input'];
  legendType: Scalars['String']['input'];
  symbolStyle: SymbolStyleInput;
  symbolValues: Array<SymbolValueInput>;
  valueField: Scalars['String']['input'];
};

export type PolygonSimpleConfigs = {
  symbolStyle?: Maybe<SymbolStyle>;
};

export type PolygonSimpleConfigsInput = {
  symbolStyle?: InputMaybe<SymbolStyleInput>;
};

export type PortalSettings = {
  bannerContent: Scalars['String']['output'];
  bannerTitle: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  footer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  layout: Scalars['String']['output'];
  name: Scalars['String']['output'];
  navigators?: Maybe<Array<Maybe<Navigator>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type PortalSettingsInput = {
  bannerContent?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  layout?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  navigators?: InputMaybe<Array<InputMaybe<NavigatorInput>>>;
};

export type Query = {
  getDatasetUploadUrl: FileUploadUrlResult;
  getDatasets: DatasetCollection;
  getMapById: Map;
  getMaps: Array<Map>;
  getPortalSettings: PortalSettings;
  getPortalSettingsByUserId: PortalSettings;
  getUser: User;
};


export type QuerygetDatasetUploadUrlArgs = {
  extension: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QuerygetDatasetsArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerygetMapByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetMapsArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerygetPortalSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type QuerygetPortalSettingsByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerygetUserArgs = {
  id: Scalars['ID']['input'];
};

export enum SUBSCRIPTION_CYCLE {
  ANNUAL = 'ANNUAL',
  FIVE_YEARS = 'FIVE_YEARS',
  FOUR_YEARS = 'FOUR_YEARS',
  MONTHLY = 'MONTHLY',
  THREE_YEARS = 'THREE_YEARS',
  TWO_YEARS = 'TWO_YEARS'
}

export enum SUBSCRIPTION_PLAN {
  AGENCY = 'AGENCY',
  BUSINESS = 'BUSINESS',
  ENTERPRISE = 'ENTERPRISE'
}

export enum SUBSCRIPTION_TYPE {
  PAID = 'PAID',
  PAID_TRIAL = 'PAID_TRIAL',
  TRIAL = 'TRIAL'
}

export type StrokeStyle = {
  color?: Maybe<Scalars['String']['output']>;
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  opacity?: Maybe<Scalars['Float']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type StrokeStyleInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  opacity?: InputMaybe<Scalars['Float']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type SymbolStyle = {
  basic?: Maybe<BasicSymbol>;
  fill?: Maybe<FillStyle>;
  isGraphic?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stroke?: Maybe<StrokeStyle>;
};

export type SymbolStyleInput = {
  basic?: InputMaybe<BasicSymbolInput>;
  fill?: InputMaybe<FillStyleInput>;
  isGraphic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stroke?: InputMaybe<StrokeStyleInput>;
};

export type SymbolValue = {
  color?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  legendVisibility?: Maybe<Scalars['Boolean']['output']>;
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  range?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<SymbolStyle>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SymbolValueInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  legendVisibility?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['String']['input']>;
  min?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  symbol?: InputMaybe<SymbolStyleInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Tool = {
  type: Scalars['String']['output'];
};

export type UpdateUserInput = {
  avatar?: InputMaybe<Scalars['AWSURL']['input']>;
  billingAddress?: InputMaybe<UserBillingAddressInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<UserPaymentMethodInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<UserSubscriptionInput>;
};

export type User = {
  avatar?: Maybe<Scalars['AWSURL']['output']>;
  billingAddress?: Maybe<UserBillingAddress>;
  companyName: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mapCollection?: Maybe<MapCollection>;
  name: Scalars['String']['output'];
  paymentMethod?: Maybe<UserPaymentMethod>;
  phone: Scalars['String']['output'];
  portalSettings?: Maybe<PortalSettings>;
  slug: Scalars['String']['output'];
  subscription: UserSubscription;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type UserBillingAddress = {
  city: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  country: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  province: Scalars['String']['output'];
  streetLine1: Scalars['String']['output'];
  streetLine2?: Maybe<Scalars['String']['output']>;
  vatNumber: Scalars['String']['output'];
};

export type UserBillingAddressInput = {
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  province: Scalars['String']['input'];
  streetLine1: Scalars['String']['input'];
  streetLine2?: InputMaybe<Scalars['String']['input']>;
  vatNumber: Scalars['String']['input'];
};

export type UserPaymentMethod = {
  cardCvv: Scalars['String']['output'];
  cardExpiresAt: Scalars['String']['output'];
  cardName: Scalars['String']['output'];
  cardNumber: Scalars['String']['output'];
};

export type UserPaymentMethodInput = {
  cardCvv: Scalars['String']['input'];
  cardExpiresAt: Scalars['String']['input'];
  cardName: Scalars['String']['input'];
  cardNumber: Scalars['String']['input'];
};

export type UserSubscription = {
  paidConfig?: Maybe<UserSubscriptionPaidConfig>;
  trialExpiresAt?: Maybe<Scalars['AWSDateTime']['output']>;
  type: SUBSCRIPTION_TYPE;
};

export type UserSubscriptionInput = {
  paidConfig?: InputMaybe<UserSubscriptionPaidConfigInput>;
  trialExpiresAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  type: SUBSCRIPTION_TYPE;
};

export type UserSubscriptionPaidConfig = {
  addons: UserSubscriptionPaidConfigAddons;
  cycle: SUBSCRIPTION_CYCLE;
  plan: SUBSCRIPTION_PLAN;
};

export type UserSubscriptionPaidConfigAddons = {
  admins: Scalars['Float']['output'];
  editors: Scalars['Float']['output'];
  maps: Scalars['Float']['output'];
  storage: Scalars['Float']['output'];
};

export type UserSubscriptionPaidConfigAddonsInput = {
  admins: Scalars['Float']['input'];
  editors: Scalars['Float']['input'];
  maps: Scalars['Float']['input'];
  storage: Scalars['Float']['input'];
};

export type UserSubscriptionPaidConfigInput = {
  addons: UserSubscriptionPaidConfigAddonsInput;
  cycle: SUBSCRIPTION_CYCLE;
  plan: SUBSCRIPTION_PLAN;
};
